import { EducatorInterface } from "../../../../../common/interfaces/EducatorInterface";

interface Props {
    formValues: {
        selectedEducators: {
            [key: string]: string;
        };
    };
    employeeId: string;
    educators: EducatorInterface[];
}

export const getEmployeeEducatorValue = (
    props: Props,
): { value: string; label: string } => {
    const { formValues, employeeId, educators } = props;

    const selectedEducatorId = formValues?.selectedEducators?.[employeeId];

    if (!selectedEducatorId) {
        return { value: "", label: "" };
    }

    const selectedEducator = educators?.find((educator) => {
        return educator.id.toString() === selectedEducatorId;
    });

    return {
        value: selectedEducatorId.toString(),
        label: selectedEducator?.name || "",
    };
};
